import moment from "moment";
import StatusCustom from "../../../../components/status/statusCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import { dateTimeToView, dateToView } from "../../../../utils/date.utils";
import OptionsButtonCustom from "../../../../components/option-button/OptionsButtonCustom";
import { useNavigate } from "react-router-dom";
import { routeName } from "../../../../routes/routeName";
import { OnlineCoursePaymentApi, paymentList } from "../../../../api/online-course-payment-master/online_course_payment_master.api";
import { setLoading, unsetLoading } from "../../../../store/loading/loading.slice";
import { useDispatch } from "react-redux";
import { renderStatus } from "./enum/enum.payment";
import { alertActive, alertError, alertSuccess } from "../../../../components/alert/swal";


export const ManageState = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const dispatch = useDispatch();

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("created_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [keyword, setKeyword] = useState<string>("");
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [data, setData] = useState<any[]>([]);
    const [showModal, setShowModal] = useState<string>("");
    const [formState, setFormState] = useState<{ course_name: string }>({
        course_name: ""
    })
    const [date_range, set_date_range] = useState<string[]>([]);

    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }
    const handleCloseModal = () => {
        setShowModal("");
        setFormState({ course_name: "" })
    }

    const headCells = [
        {
            id: "1", width: 100, sortable: true, disablePadding: false, align: 'center', label: t("COMPLAINTS_ORDER")
        },
        {
            id: "2", disablePadding: false, width: 140, align: "center", label: t("รหัสคอร์สเรียน")
        },
        {
            id: "3", disablePadding: false, width: 140, align: "center", label: t("ชื่อคอร์สเรียน")
        },
        {
            id: "4", disablePadding: false, width: 140, align: "center", label: t("ผู้สั่งซื้อ")
        },
        {
            id: "5", disablePadding: false, width: 140, align: "center", label: t("วันที่ชำระเงิน")
        },
        {
            id: "6", disablePadding: false, align: "center", width: 140, label: t("สถานะ")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 100, class: matches && data.length > 0, label: ""
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            created_date,
            id_online_course_payment,
            online_course_no,
            online_course_name,
            order_by,
            online_course_payment_status
        } =
            objData;

        // subject_no: "BUD32",
        // subject_name: "ปรัชญาพุทธศาสตร์",
        // status: "ACTIVE",
        // create_date: new Date(),
        // create_by: "นางมาริสา มากดีดก"
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "center",
                    label: online_course_no || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: online_course_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: order_by || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: created_date ? dateToView(created_date) : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: <StatusCustom
                        disableMaxWidth
                        text={renderStatus(online_course_payment_status)}
                        type={renderStatus(online_course_payment_status)}
                    />
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onEditClick={() => navigate(routeName.cms.course_online_payment_detail.replace(":id", id_online_course_payment))}
                            onViewClick={() => navigate(routeName.cms.course_online_payment_view.replace(":id", id_online_course_payment))}
                            onDeleteClick={() => handleDelete(id_online_course_payment)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDelete = (id_online_course_payment: number) => {
        alertActive(t("ลบรายการ"), t("ท่านต้องการลบรายการนี้?"), undefined, undefined, async () => {
            dispatch(setLoading());
            await OnlineCoursePaymentApi.deleted(id_online_course_payment).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                    alertSuccess(t("ลบรายการ"), t("ลบรายการ เรียบร้อยแล้ว"))
                }
            }).catch((err) => {
                console.log(err);
                alertError(t("ลบรายการ"), t("ลบรายการ ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    const handleGetData = useCallback(async () => {
        let query: paymentList = {
            page: page,
            limit: pageLimit,
            sortBy: sortBy,
            sortType: sortType
        }
        dispatch(setLoading());
        if (keyword) query = { ...query, keyword: keyword }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        await OnlineCoursePaymentApi.paymentList(query).then((res) => {
            if (res.status < 300) {
                const data_item = res.data?.data?.items || [];
                const total_item = res.data?.data?.meta?.totalItems || [];
                setData(data_item);
                setTotalItems(total_item)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, sortBy, sortType, endDate, startDate, keyword])

    useEffect(() => {
        handleGetData()
    }, [handleGetData])


    return {
        page,
        pageLimit,
        data,
        sortBy,
        sortType,
        handleRequestSort,
        setPage,
        setPageLimit,
        headCells,
        totalItems,
        renderData,
        handleCloseModal,
        formState,
        showModal,
        setShowModal,
        setFormState,
        setKeyword,
        handleChangeDateRange,
        handleClearDateRange,
        date_range
    }
}